import React, { useRef } from 'react';
import gql from 'graphql-tag';
import { sort } from '@sporkbytes/api-client/MealTypes';
import { Alert } from '@sporkbytes/material-ui-kit-react';

import ActionMenu from 'components/utilities/ActionMenu';
import EditableSortOrder from 'components/forms/EditableSortOrder';
import RemoteTable from 'components/content/RemoteTable';
import Page from 'components/layout/Page';
import PageHeader from 'components/content/PageHeader';

import { createEditAction } from 'services/actionMenu';
import { useAuth } from 'services/auth';
import axios from 'services/data';

const getMealTypesQuery = searchTerm =>
	gql`
		query MealTypes(
			$sortOrderOrderBy: order_by
			$nameOrderBy: order_by
			$limit: Int!
			$offset: Int!
		) {
			MealTypes(
				where: { name: { _ilike: "%${searchTerm}%" } }
				order_by: { sortOrder: $sortOrderOrderBy, name: $nameOrderBy }
				limit: $limit
				offset: $offset
			) {
				id
				name	
				sortOrder
			}
			MealTypes_aggregate {
				aggregate {
					count
				}
			}
		}
	`;

const Detail = () => {
	const { userCan } = useAuth();
	const ref = useRef();

	return (
		<Page title="Meal Types">
			<PageHeader headerText="Meal Types" />
			<Alert type="info">
				Meal types are for driving how menus appear on the partner list.
				They differ from meal categories in that meal categories help us
				analyze financials.
			</Alert>
			<RemoteTable
				tableRef={ref}
				columns={[
					{
						title: 'Sort Order',
						field: 'sortOrder',
						render: ({ id, sortOrder }) => (
							<EditableSortOrder
								onSave={value =>
									sort(axios, id, {
										newValue: value,
									}).then(ref.current.onQueryChange)
								}
								permissions={['meal-types:edit']}
								required={true}
								value={sortOrder}
							/>
						),
					},
					{
						title: 'Name',
						field: 'name',
					},
					{
						title: 'Actions',
						field: 'actions',
						render: ({ id, name }) => (
							<ActionMenu
								options={[
									createEditAction({
										entityId: id,
										entityName: name,
										entityType: 'MealTypes',
										userCan,
									}),
								]}
							/>
						),
					},
				]}
				getQuery={getMealTypesQuery}
				defaultOrderBy="sortOrder"
				defaultOrderDirection="asc"
				queryEntity="MealTypes"
				addNewEntityRouteName="mealTypesCreate"
				entityToAddName="Meal Type"
				canAddNewEntity={userCan(['meal-types:create'])}
			/>
		</Page>
	);
};

export default Detail;
